'use strict';
import React, { PureComponent } from 'react';
import DetalleSuperior from './DetalleSuperior';
import DatosAuditoria from './DatosAuditoria';
import DatosReproceso from './DatosReproceso';
import SeccionRenglones from './SeccionRenglones';
import DatosComentarios from './DatosComentarios';
import { GenericModal } from 'com-gyf-webcore-userinterfacecomponents'; 

class ModalDetalleAsiento extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            mensajeError: '',
            muestraMensajeConfirmacion: false
        };      
        this.aceptarCambios = this.aceptarCambios.bind(this);
    }

    componentDidMount() {
        //Cuando el modal se active, al ser de un largo extenso, se posiciona al inicio de la ventana para que pueda visualizarse el modal desde el inicio
        //y no desde el lugar del botón donde se activó
        window.scrollTo(0, 0)

        window.onbeforeunload = function (event) {
            if (sessionStorage.getItem('PantallaCambios') == "true") {
              return "¿Quieres salir de este sitio web? Es posible que los cambios no se guarden.";
            }
          };
    }

    componentWillUnmount() {

        const {registro, desplegarDatosDetalleAsiento, cambiarValorInput, cambiarInputActivo, limpiarModalAsientosContables } = this.props

        // Si la opcion seleccionada en el combo de estado es "Baja", se evita hacer el reseteo de los valores del state
        // de manera tal que los datos persistan en caso de tocar "Cancelar" en el modal de confirmacion de baja y se retorne al modal de detalle
        if( !(registro && registro.EstadoDescripcionCombo && registro.EstadoDescripcionCombo.toUpperCase().includes("BAJA")) ){
            desplegarDatosDetalleAsiento(null);
            cambiarValorInput("modalAsientosContables","inputCuentaContable", "");
            cambiarInputActivo("modalAsientosContables", "");
            limpiarModalAsientosContables();
            window.onbeforeunload = null;
        }
    }

    aceptarCambios() {
        const { registro,  renglonesAgregadosManualmente, guardarActualizarAsientoContable, mostrarOcultarModalAsientosContables, setearOrigenLlamadoModalConfirmacionBaja} = this.props;
        const { renglonesValidos, mensajeError } = this.validarRenglones(renglonesAgregadosManualmente);

        let estadoCombo = registro && registro.EstadoDescripcionCombo && registro.EstadoDescripcionCombo.toUpperCase().includes("BAJA")

        if (renglonesValidos) {
            if(!!estadoCombo){
                setearOrigenLlamadoModalConfirmacionBaja("modalDetalleAsiento");
                mostrarOcultarModalAsientosContables("modalDetalleAsiento", false);
                mostrarOcultarModalAsientosContables("modalConfirmarBajaAsientos", true);

            }else{

             guardarActualizarAsientoContable("modalAsientosContables")

            }    
        } else {
            this.setState({ mensajeError });
        }
    }

    validarRenglones(registrosManuales) {
        const todosLosRegistros = [...registrosManuales];
        
        const registrosFiltrados = todosLosRegistros.filter(reg => !reg.EliminaRenglon);
        
        let renglonesValidos = true;
        let mensajeError = "";
    
        // Validar si hay algún registro sin DescripcionRenglon, CuentaContableCodigo o ImporteAsiento
        if (registrosFiltrados.some(reg => !reg.DescripcionRenglon || !reg.CuentaContableCodigo || !reg.ImporteAsiento)) {
            renglonesValidos = false;
            mensajeError = "Por favor complete todos los campos para poder guardar el asiento.";
        }
    
        return { renglonesValidos, mensajeError };
    }

    cancelarCambios(event){
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            this.setState({muestraMensajeConfirmacion : true})
            event.preventDefault();
            $("#cancel-modal").modal({ backdrop: "static" });
            $(".modal-backdrop").remove();
        } else {
            $("#cancel-modal").modal("hide");
            this.props.mostrarOcultarModalAsientosContables("modalDetalleAsiento", false)
        } 
    }

    onModalConfirmClick() {
        if (sessionStorage.getItem('PantallaCambios') == "true") {
            sessionStorage.removeItem('PantallaCambios')
        }
        $("#cancel-modal").modal("hide");
        this.props.mostrarOcultarModalAsientosContables("modalDetalleAsiento", false)
    }

    render() {
        const {
            registro,
            comboEstadosAsientos,
            permisosUsuario,
            registroDatosReproceso,
            datosExcelAsientosContables,
            renglonesContablesAsiento,
            renglonesContablesModelo,
            cuentasContables,
            inputActivo,
            inputBuscadorCuentaContable,
            detalleRenglonDatosDesplegados,
            detalleAsientoDatosDesplegados,
            centrosCosto,
            renglonesAgregadosManualmente,
            renglonesManualesFiltrados,
            renglonesAsientoIdentificados,
            monedasAsiento
        } = this.props;

        //ACTIONS
        const {
            buscarCuentasContables,
            cambiarValorInput,
            cambiarInputActivo,
            descargaTipoMovimiento,
            desplegarDatosDetalleAsiento,
            desplegarDatosDetalleRenglon,
            mostrarOcultarModalAsientosContables,
            armarDatosExportacionExcel,
            descargarExcel,
            agregarRenglonManual,
            modificarRenglonManual,
            cargarRenglonesManualesFiltradosDelModelo,
            cambiarEstadoAsiento
        } = this.props;

        let estiloDatosAuditoria = detalleAsientoDatosDesplegados == "datosAuditoria";
        let estiloDatosReproceso = detalleAsientoDatosDesplegados == "datosReproceso";
        let estiloDatosComentarios = detalleAsientoDatosDesplegados == "datosComentarios";
        
        return (
            <div className="modalContainer ModalDetalleContainerLarge AsientosContables__modalContainerDetalleAsiento">
               {!this.state.muestraMensajeConfirmacion && (
                <div className="AsientosContablesModalContainer">
                    <div className="AsientosContablesModalContainer__header">
                        <div className="ABMModelosModalContainer__contenedorTituloBoton">
                            <div className="ABMModelosModalContainer__titulo AsientosContables__modalDetalleAsiento__titulo">Detalle de asiento contable</div>
                            <div className="ABMModelosModalContainer__botonCerrar" onClick={(event) => this.cancelarCambios(event)}></div>
                        </div>
                        <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria"></div>
                    </div>
                    <div className="AsientosContablesModalContainer__body">
                            <DetalleSuperior 
                                    registro={registro} 
                                    permisosUsuario={permisosUsuario}
                                    comboEstadosAsientos={comboEstadosAsientos}
                                    cambiarEstadoAsiento={cambiarEstadoAsiento}
                            />
                        <div className="AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorDatosAuditoriaReproceso">
                            <div className="AsientosContables--floatLeft" onClick={() => desplegarDatosDetalleAsiento("datosAuditoria")}>
                                <div className={"AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorDatosAuditoriaReprocesoIndividual" + (estiloDatosAuditoria ? " AsientosContables__modalDetalleAsiento__contenedorDatosAuditoriaReprocesoIndividual--activo" : "")}>
                                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__tituloDatosAuditoria">
                                        Datos de auditoria
                                    </div>

                                    <div className={"AsientosContables--floatLeft" + (estiloDatosAuditoria ? " seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : " seccionRenglonesModelo__renglonModelo__trianguloDown AsientosContables__modalDetalleAsiento__flechaDesplegableAuditoriaReproceso")}></div>
                                </div>
                            </div>

                            {registro && registro.Comentarios?
                             <div className="AsientosContables--floatLeft" onClick={() => desplegarDatosDetalleAsiento("datosComentarios")}>
                                <div className={"AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorDatosAuditoriaReprocesoIndividual" + (estiloDatosComentarios ? " AsientosContables__modalDetalleAsiento__contenedorDatosAuditoriaReprocesoIndividual--activo" : "")}>
                                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__tituloDatosComentarios">
                                        Comentarios
                                    </div>
                                    <div className={"AsientosContables--floatLeft " + (estiloDatosComentarios ? " seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : " seccionRenglonesModelo__renglonModelo__trianguloDown AsientosContables__modalDetalleAsiento__flechaDesplegableAuditoriaReproceso")}></div>
                                </div>
                            </div> 
                            : null
                         }
                         

                         {registro && registro.FechaReproceso?
                             <div className="AsientosContables--floatLeft" onClick={() => desplegarDatosDetalleAsiento("datosReproceso")}>
                                <div className={"AsientosContables--overflowHidden AsientosContables__modalDetalleAsiento__contenedorDatosAuditoriaReprocesoIndividual" + (estiloDatosReproceso ? " AsientosContables__modalDetalleAsiento__contenedorDatosAuditoriaReprocesoIndividual--activo" : "")}>
                                    <div className="AsientosContables--floatLeft AsientosContables__modalDetalleAsiento__tituloDatosReproceso">
                                        Datos de reproceso
                                    </div>
                                    <div className={"AsientosContables--floatLeft " + (estiloDatosReproceso ? " seccionRenglonesModelo__renglonModelo__trianguloUp seccionRenglonesModelo__renglonModelo__trianguloUp--activo" : " seccionRenglonesModelo__renglonModelo__trianguloDown AsientosContables__modalDetalleAsiento__flechaDesplegableAuditoriaReproceso")}></div>
                                </div>
                            </div> 
                            : null
                         }

                        </div>
                        <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria AsientosContables__modalDetalleAsiento__bodyLineaDivisoria"></div>

                        <DatosAuditoria
                            estaDesplegado={estiloDatosAuditoria}
                            registro = {registro} 
                        />

                        <DatosComentarios
                            estaDesplegado={estiloDatosComentarios}
                            registro = {registro} 
                        />

                        <DatosReproceso
                            estaDesplegado={estiloDatosReproceso}
                            registro = {registro} 
                            registroDatosReproceso={registroDatosReproceso}
                        />

                        {estiloDatosAuditoria || estiloDatosReproceso || estiloDatosComentarios ?
                            <div className="AsientosContables__modalDetalleAsiento__lineaDivisoria AsientosContables__modalDetalleAsiento__bodyLineaDivisoria"></div>
                        :
                            null
                        }

                     {registro && renglonesContablesAsiento && renglonesContablesModelo ? (
                        <SeccionRenglones 
                            registroAsientoContable={registro}
                            renglonesContablesAsiento={renglonesContablesAsiento}
                            renglonesAsientoIdentificados={renglonesAsientoIdentificados}
                            renglonesContablesModelo={renglonesContablesModelo}
                            renglonesAgregadosManualmente={renglonesAgregadosManualmente}
                            renglonesManualesFiltrados={renglonesManualesFiltrados}
                            cuentasContables={cuentasContables}
                            inputBuscadorCuentaContable={inputBuscadorCuentaContable}
                            cambiarInputActivo={cambiarInputActivo}
                            inputActivo={inputActivo}
                            agregarRenglonManual={agregarRenglonManual}
                            modificarRenglonManual={modificarRenglonManual}
                            centrosCosto={centrosCosto}
                            detalleRenglonDatosDesplegados={detalleRenglonDatosDesplegados}
                            cargarRenglonesManualesFiltradosDelModelo={cargarRenglonesManualesFiltradosDelModelo}
                            descargaTipoMovimiento={descargaTipoMovimiento}
                            desplegarDatosDetalleRenglon={desplegarDatosDetalleRenglon}
                            cambiarValorInput={cambiarValorInput}
                            registroDatosReproceso={registroDatosReproceso}
                            datosExcelAsientosContables={datosExcelAsientosContables}
                            armarDatosExportacionExcel={armarDatosExportacionExcel}
                            descargarExcel={descargarExcel}
                            buscarCuentasContables={buscarCuentasContables}
                            permisosUsuario={permisosUsuario}
                            monedasAsiento={monedasAsiento}
                        />
                    ) : null}
                    </div>
                    {this.state.mensajeError && <p className="genericLabel warningMessage AsientosContables__marginWarningMessage">{this.state.mensajeError}</p>}
                    <div className="AsientosContablesModalContainer__footer">
                        <div>
                            <button className="ABMModelosModalContainer__botonAceptar" onClick={() => this.aceptarCambios()}>
                                Aceptar
                            </button>
                        </div>

                        <div>
                            <button className="ABMModelosModalContainer__botonCancelar" onClick={(event) => this.cancelarCambios(event)}>
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
                )}

             {this.state.muestraMensajeConfirmacion && (
                <GenericModal id="cancel-modal"
                    className="modal fade-out modal-center modal-center-asientos-contables"
                    type="ALL_CUSTOM"
                    screenSize="modal-dialog modal-generic"
                    header={<h2 className="modal-title">Descartar Cambios</h2>}
                    footer={<div className="row">
                        <div className="col-xs-5">
                            <button type="button" className="btn btn-cta" onClick={() => this.onModalConfirmClick()}>Descartar Cambios</button>
                        </div>
                        <div className="col-xs-7">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal"    
                             onClick={() => { this.setState({ muestraMensajeConfirmacion: false });
                                                $("#cancel-modal").modal("hide") }} >Cancelar</button>
                        </div>
                    </div>}
                    body={<p>Se han realizado modificaciones, en caso de no guardarlos se perderán ¿Desea descartar los cambios?</p>}
                />
            )}
            </div>
        );
    }
}

export default ModalDetalleAsiento;